import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './index.module.css';
import { editAdminImage, selectUserDetails } from '../../../redux/features/auth/authSlice';
import DefaultImage from '../../../assets/images/icons/blank_profile_pic.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-regular-svg-icons';
import { adminChangePassword, editAdminProfileImage } from '../../../redux/features/auth/authService';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import ClipLoader from "react-spinners/ClipLoader";
import { showToast } from '../../../components/ToastMsg';
import GridLoader from 'react-spinners/GridLoader';

const Profile = () => {
  const dispatch = useDispatch();
  const { details, isUserDetailsLoading } = useSelector(selectUserDetails);
  const { imageUpdateStatus } = useSelector(editAdminImage);
  const [previewEditThumbnailImage, setPreviewEditThumbnailImage] = useState(null);

  const [credentials, setCredentials] = useState({ newPassword: '', confirmPassword: '' });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [errors, setErrors] = useState({ newPassword: '', confirmPassword: '' });
  const [disabledBtn, setBtnDisable] = useState(false);

  if (isUserDetailsLoading) {
    return <div className={`loader-style`}>
      <GridLoader color="#c93b25" />
    </div>;
  }

  if (!details) {
    return <p>No user details found. Please log in.</p>;
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewEditThumbnailImage(e.target.result);
      };
      reader.readAsDataURL(file);
      dispatch(editAdminProfileImage({ file }))
        .unwrap()
        .then((response) => {
          if (response.success === true) {
            showToast("success", response.message);
          } else {
            showToast("error", response.message);
          }
        })
        .catch((error) => {
          showToast("error", error.message);
        });
    }
  };

  const validatePassword = () => {
    const errors = {};
    if (!credentials.newPassword) {
      errors.newPassword = 'Password is required!'
    }
    if (!credentials.confirmPassword) {
      errors.confirmPassword = 'Confirm Password is required!'
    }
    if (credentials.newPassword !== credentials.confirmPassword) {
      errors.confirmPassword = 'Password & Confirm Password must be matched!'
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    } else {
      return true;
    }
  }

  const handlePasswordChange = async () => {
    if (validatePassword()) {
      setBtnDisable(true);
      try {
        const response = dispatch(adminChangePassword(credentials)).unwrap()
        if (response.success === true) {
          showToast("success", response.message);
          setBtnDisable(false);
        } else {
          showToast("error", response.message);
          setBtnDisable(false);
        }
      }
      catch (error) {
        showToast("error", error.message);
        setBtnDisable(false);
      };
    }
  }

  return (
    <div className={`main-card`}>
      <h1 className={`body-title`}>Profile</h1>
      <div className={styles.formContainer}>
        <form className={styles.paymentForm}>
          <div className={styles.profileRow}>
            <div className={styles.profilePicture}>
              <img src={previewEditThumbnailImage ? previewEditThumbnailImage : details?.image_url ? details?.image_url : DefaultImage} className={styles.imageSec} alt='Profile' />
              {imageUpdateStatus === 'loading' ?
                <label className={styles.uploadIcon}>
                  <ClipLoader size={20} />
                </label> :
                <label className={styles.uploadIcon}>
                  <FontAwesomeIcon icon={faImage} color='gray' />
                  <input
                    type="file"
                    accept="image/*"
                    className={styles.fileInput}
                    onChange={handleFileChange}
                  />
                </label>}
            </div>
            <div className={styles.nameSec}>
              <p className={styles.name}>{details?.full_name}</p>
              <p className={styles.email}>{details?.email}</p>
              <p className={styles.email}>{details?.phone_number}</p>
            </div>
          </div>
          {/* <div className={styles.inputRow}>
            <div className={styles.paymentInputFormGroup}>
              <div className={`${styles.paymentInputGroup} input-group`}>
                <div>
                  <label className={`form-label`}>Employee ID</label>
                </div>
                <p className={styles.profileDetails}>{details?.reg_number}</p>
              </div>
            </div>
            <div className={styles.paymentInputFormGroup}>
              <div className={` ${styles.paymentInputGroup} input-group`}>
                <div>
                  <label className={`form-label`}>Address</label>
                </div>
                <p className={styles.profileDetails}>{details?.address}</p>
              </div>
            </div>
          </div>
          <div className={`inputRowLine`}></div>
          <div className={styles.inputRow}>
            <div className={styles.paymentInputFormGroup}>
              <div className={`${styles.paymentInputGroup} input-group`}>
                <div>
                  <label className={`form-label`}>NIC Number</label>
                </div>
                <p className={styles.profileDetails}>{details?.nic}</p>
              </div>
            </div>
            <div className={styles.paymentInputFormGroup}>
              <div className={` ${styles.paymentInputGroup} input-group`}>
                <div>
                  <label className={`form-label`}>Phone Number</label>
                </div>
                <p className={styles.profileDetails}>{details?.phone_number}</p>
              </div>
            </div>
          </div>
          <div className={`inputRowLine`}></div> */}
        </form>
      </div>
      <h1 className={`body-title ${styles.passDiv}`}>Create New Password</h1>
      <div className={styles.formContainer}>
        <form className={styles.paymentForm}>
          <div className={styles.inputRow}>
            <div className={styles.paymentInputFormGroup}>
              <div className={`${styles.paymentInputGroup}`}>
                <div>
                  <label className={`form-label`}>Password</label>
                </div>
                <input
                  type={passwordVisible ? "text" : "password"}
                  placeholder="********************"
                  value={credentials.newPassword}
                  onChange={(e) => {
                    setCredentials({ ...credentials, newPassword: e.target.value });
                    setErrors({ ...errors, newPassword: '' })
                  }}
                  className={`${styles.paymentInput} primary-input`}
                />
                {!passwordVisible ?
                  <FontAwesomeIcon icon={faEyeSlash} style={{ marginLeft: '-40px' }} onClick={() => setPasswordVisible(true)} /> :
                  <FontAwesomeIcon icon={faEye} style={{ marginLeft: '-40px' }} onClick={() => setPasswordVisible(false)} />}
              </div>
              {errors.newPassword && (
                <p className={`text-danger`}>{errors.newPassword}</p>
              )}
            </div>
            <div className={styles.paymentInputFormGroup}>
              <div className={` ${styles.paymentInputGroup}`}>
                <div>
                  <label className={`form-label`}>Confirm Password</label>
                </div>
                <input
                  type={confirmPasswordVisible ? "text" : "password"}
                  placeholder="********************"
                  value={credentials.confirmPassword}
                  onChange={(e) => {
                    setCredentials({ ...credentials, confirmPassword: e.target.value });
                    setErrors({ ...errors, confirmPassword: '' })
                  }}
                  className={`${styles.paymentInput} primary-input`}
                />
                {!confirmPasswordVisible ?
                  <FontAwesomeIcon icon={faEyeSlash} style={{ marginLeft: '-40px' }} onClick={() => setConfirmPasswordVisible(true)} /> :
                  <FontAwesomeIcon icon={faEye} style={{ marginLeft: '-40px' }} onClick={() => setConfirmPasswordVisible(false)} />}

              </div>
              {errors.confirmPassword && (
                <p className={`text-danger`}>{errors.confirmPassword}</p>
              )}
            </div>
          </div>
          <button type="button" className={`btn-primary`} onClick={handlePasswordChange} disabled={disabledBtn}>
            Save Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profile;